import { render, staticRenderFns } from "./SavedCarts.vue?vue&type=template&id=70ca8234&scoped=true"
import script from "./SavedCarts.vue?vue&type=script&lang=js"
export * from "./SavedCarts.vue?vue&type=script&lang=js"
import style0 from "./SavedCarts.vue?vue&type=style&index=0&id=70ca8234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca8234",
  null
  
)

export default component.exports